import { createApiConfig } from "../config";

import { HOSPITAL_INFORMATION_API_URL } from "../routes"

const apiConfig = createApiConfig();


// super admin crud
export const getHospitalInformation = (id) => apiConfig.get(`${HOSPITAL_INFORMATION_API_URL}/${id}`);

// CREATE admin User

export const addHospitalInformation = (id, data) => apiConfig.post(`${HOSPITAL_INFORMATION_API_URL}/${id}`, data);

// DELETE admin User

export const deleteHospitalInformation = (id) => apiConfig.delete(`${HOSPITAL_INFORMATION_API_URL}/${id}`);

// Update admin User

export const updateHospitalInformation = (id,data) => apiConfig.put(`${HOSPITAL_INFORMATION_API_URL}/${id}`, data);